module.exports = __webpack_public_path__ + "img/智能素材管理.842023ca.gif";